import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "18",
  height: "18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><path id=\"a\" d=\"M0 0h18v18H0z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"></use></mask><path fill=\"currentColor\" d=\"M1.707 6.293A.999.999 0 0 0 0 7v4a1 1 0 0 0 1.707.707l2-2a1 1 0 0 0 0-1.414zM6 0a1 1 0 0 0-1 1v16a1.001 1.001 0 0 0 2 0V1a1 1 0 0 0-1-1m11 2H9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2m-2 8H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2M9 8h4a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2m2 6H9a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2\" mask=\"url(#b)\"></path></g>", 2)
  ]))]))
}
export default { render: render }